import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=3c9359b4&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9359b4",
  null
  
)

component.options.__file = "Menu.vue"
export default component.exports